import parsePhoneNumber, { CountryCode } from 'libphonenumber-js';

export const formatIntlPhoneNumber = (phone: string = '', defaultCountryCode: CountryCode = 'US') => {
    if (!phone) return '';
    try {
        const phoneNumber = parsePhoneNumber(phone, defaultCountryCode);
        if (phoneNumber?.isValid()) {
            return `+${phoneNumber?.countryCallingCode} ${phoneNumber?.formatNational()}`;
        }
    } catch (error) {
        // eslint-disable-next-line no-console
        console.log('error', phone);
    }
    return phone;
};

export const formatPhoneNumber = (phone: string = '', defaultCountryCode: CountryCode = 'US') => {
    if (!phone) return '';
    try {
        const phoneNumber = parsePhoneNumber(phone, defaultCountryCode);
        if (phoneNumber?.isValid()) {
            return {
                countryCode: `+${phoneNumber?.countryCallingCode}`,
                phone: phoneNumber?.nationalNumber,
                isoCode: phoneNumber?.country?.toLowerCase(),
            };
        }
    } catch (error) {
        // eslint-disable-next-line no-console
        console.log('error', phone);
    }
    return phone;
};

export default formatIntlPhoneNumber;
